import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const useMergedDropzoneRef = (dropzoneOptions, externalRef) => {
  const { getRootProps, ...dropzoneRest } = useDropzone(dropzoneOptions);
  const { dropzoneRef, ...rootProps } = getRootProps({ role: 'presentation', refKey: 'dropzoneRef' });

  const mergedRef = useCallback(
    (node) => {
      if (typeof externalRef === 'function') externalRef(node);
      else if (externalRef) externalRef.current = node;
      dropzoneRef.current = node;
    },
    [externalRef, dropzoneRef]
  );

  return { ...dropzoneRest, rootProps, mergedRef };
};

export default useMergedDropzoneRef;
